module.exports = __webpack_public_path__ + "img/1097one4.6d6c3d51.png";